/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */
import mapEcharts from '@/components/app/chinaMapEcharts/index.vue';
export default {
    name: 'szsj',
    components: {mapEcharts},
    data() {
        return {};
    },
    methods: {}
};

